/**
 * RoomList — sidebar со списком чат-комнат внутри ChatPanel.
 * Поиск по имени, кнопка «Новый чат», unread-каунтер, кнопка удаления.
 *
 * Чисто презентационный — все handlers приходят пропсами; локальный
 * state — только строка фильтра.
 */

import { useState } from 'react'
import { Plus, Trash2 } from 'lucide-react'
import { formatTime, getInitials } from '../../../utils/chatHelpers'
import { getRoomIcon } from './internals'

export default function RoomList({ rooms, activeRoom, onSelect, onNewChat, onDeleteRoom }) {
    const [search, setSearch] = useState('')

    const filtered = rooms.filter(r =>
        !search || (r.name || '').toLowerCase().includes(search.toLowerCase())
    )

    const handleDelete = (e, room) => {
        e.stopPropagation()
        if (window.confirm(`Удалить диалог «${room.name || 'Без имени'}»?`)) {
            onDeleteRoom?.(room.id)
        }
    }

    return (
        <div className="chat-rooms">
            <div className="chat-rooms__search">
                <input
                    className="chat-rooms__search-input"
                    placeholder="Поиск чатов..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </div>

            <button className="chat-rooms__new-btn" onClick={onNewChat}>
                <Plus size={14} />
                Новый чат
            </button>

            <div className="chat-rooms__list">
                {filtered.length === 0 ? (
                    <div className="chat-empty chat-empty--compact">
                        <div className="chat-empty__text">
                            {search ? 'Ничего не найдено' : 'Нет чатов'}
                        </div>
                    </div>
                ) : (
                    filtered.map(room => {
                        const RoomIcon = getRoomIcon(room.type)
                        const avatarClass = room.type === 'channel'
                            ? 'chat-room-item__avatar chat-room-item__avatar--channel'
                            : room.type === 'announcement'
                                ? 'chat-room-item__avatar chat-room-item__avatar--announcement'
                                : 'chat-room-item__avatar'

                        return (
                            <div
                                key={room.id}
                                className={`chat-room-item ${activeRoom?.id === room.id ? 'chat-room-item--active' : ''}`}
                                onClick={() => onSelect(room)}
                            >
                                <div className={avatarClass}>
                                    {room.avatar_url ? (
                                        <img src={room.avatar_url} alt="" />
                                    ) : RoomIcon ? (
                                        <RoomIcon size={18} />
                                    ) : (
                                        getInitials(room.name)
                                    )}
                                </div>

                                <div className="chat-room-item__info">
                                    <div className="chat-room-item__name">{room.name || 'Без имени'}</div>
                                    <div className="chat-room-item__last-msg">
                                        {room.last_message ? (
                                            <>
                                                {room.last_message.sender_name && (
                                                    <span className="fw-600">
                                                        {room.last_message.sender_name.split(' ')[0]}:{' '}
                                                    </span>
                                                )}
                                                {room.last_message.content || '📎 Файл'}
                                            </>
                                        ) : (
                                            'Нет сообщений'
                                        )}
                                    </div>
                                </div>

                                <div className="chat-room-item__meta">
                                    {room.last_message?.created_at && (
                                        <span className="chat-room-item__time">
                                            {formatTime(room.last_message.created_at)}
                                        </span>
                                    )}
                                    {room.unread_count > 0 && (
                                        <span className="chat-room-item__unread">
                                            {room.unread_count > 99 ? '99+' : room.unread_count}
                                        </span>
                                    )}
                                    <button
                                        className="chat-room-item__delete-btn"
                                        onClick={(e) => handleDelete(e, room)}
                                        title="Удалить диалог"
                                    >
                                        <Trash2 size={14} />
                                    </button>
                                </div>
                            </div>
                        )
                    })
                )}
            </div>
        </div>
    )
}
